<div class="fixed bottom-6 right-6 z-50 flex flex-col gap-3 pointer-events-none">
  @for (toast of toasts; track toast.id) {
    <div
      [ngClass]="{
        'bg-red-50 border-red-200 text-red-900': toast.type === 'error',
        'bg-green-50 border-green-200 text-green-900': toast.type === 'success',
        'bg-yellow-50 border-yellow-200 text-yellow-900': toast.type === 'warning',
        'bg-blue-50 border-blue-200 text-blue-900': toast.type === 'info',
        'bg-purple-50 border-purple-200 text-purple-900': toast.type === 'notification',
      }"
      class="border rounded-lg shadow-lg p-4 max-w-sm pointer-events-auto animate-slideIn"
    >
      <div class="flex items-start gap-3">
        <div
          [ngClass]="{
            'bg-red-100 text-red-600': toast.type === 'error',
            'bg-green-100 text-green-600': toast.type === 'success',
            'bg-yellow-100 text-yellow-600': toast.type === 'warning',
            'bg-blue-100 text-blue-600': toast.type === 'info',
            'bg-purple-100 text-purple-600': toast.type === 'notification',
          }"
          class="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm"
        >
          {{ getIcon(toast.type) }}
        </div>

        <div class="flex-1 min-w-0">
          <h4 class="font-semibold text-sm mb-1">{{ toast.title }}</h4>
          <p class="text-xs opacity-90 break-words">{{ toast.message }}</p>
          @if (toast.actionUrl) {
            <button
              (click)="handleAction(toast)"
              class="mt-2 text-xs font-semibold underline hover:opacity-75 transition"
            >
              Take me there →
            </button>
          }
        </div>

        <button
          (click)="closeToast(toast.id)"
          class="flex-shrink-0 text-lg leading-none hover:opacity-75 transition"
          aria-label="Close notification"
        >
          ✕
        </button>
      </div>
    </div>
  }
</div>
